import React, { useContext } from "react";
import { AppContext } from "../window";
import { useTranslation } from "../i18n";
import { SliderContext } from "./App";
import PersonIcon from '@mui/icons-material/Person';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import CloseIcon from '@mui/icons-material/Close';
import FavoriteIcon from '@mui/icons-material/Favorite';
import MoreVertIcon from '@mui/icons-material/MoreVert';

export const NoUserModal: React.FC = () => {
  const { t } = useTranslation();
  const { texts } = useContext(AppContext);
  const { legacyMode } = useContext(SliderContext);
  const preferenceHref = legacyMode ? "/user/area/update" : "/profile";

  return (
    <div className="slide position-relative align-items-center flex-grow-1 flex-md-grow-0 d-flex flex-column col-lg-6 offset-lg-3 col-xl-4 offset-xl-4 shadow no-user" role="alert" aria-live="assertive" aria-atomic="true">
      <div className="slide-picture backdrop flex-grow"></div>
      <div className="slide-picture flex-grow">
        <div className="thumbnail-overlay upper d-flex align-items-center dark blur plain">
          <div className="no-user-content text-center w-100 px-3">
            <div className="d-flex justify-content-center mb-3">
              <div className="no-results-icon img-thumbnail rounded-circle" style={{ backgroundImage: "url('/images/no-results.png')" }}></div>
            </div>
            <p className="text mb-3">{t('slider.no_users')}</p>
            <div className="d-grid gap-3">
              <a className="btn btn-primary w-100 d-flex align-items-center justify-content-center" href={preferenceHref}>
                <PersonIcon className="me-2" /> {t('slider.my_preferences')}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="slide-toolbar">
        <div className="thumbnail-overlay lower dark plain"></div>
        <div className="buttons d-flex justify-content-between align-items-center p-3">
          <div>
            <div className="btn btn-secondary rounded-circle shadow-sm btn-slider-action"><StarBorderIcon fontSize="small" /></div>
          </div>
          <div>
            <div className="btn btn-outline-secondary rounded-circle shadow-sm btn-slider-action"><CloseIcon fontSize="large" /></div>
          </div>
          <div>
            <div className="btn btn-primary rounded-circle shadow-sm btn-slider-action"><FavoriteIcon fontSize="large" /></div>
          </div>
          <div>
            <span className="btn btn-secondary rounded-circle shadow-sm btn-slider-action align-middle"><MoreVertIcon fontSize="small" /></span>
          </div>
        </div>
      </div>
    </div>
  );
};
